// extracted by mini-css-extract-plugin
export default {"container":"ManageSetsForSnP__container___wXkbA","curriculumToggleContainer":"ManageSetsForSnP__curriculumToggleContainer___N646h","footer":"ManageSetsForSnP__footer___ulQq4"};